import { sendTicketsToEmailLoadingSelector } from '@/features/loading/loadingSelectors';
import { TransText } from '@/i18n/trans/text';
import { useSelector } from '@/store/utils';
import { breakpoints } from '@/utils/breakpoints';
import { Button } from '@packages/webshop-design-system';
import { type FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useMediaQuery } from 'react-responsive';

interface SendTicketsToEmailFooterProps {
  onClose: () => void;
  formId: string;
}

const SendTicketsToEmailFooter: FC<SendTicketsToEmailFooterProps> = ({
  onClose,
  formId,
}) => {
  const loading = useSelector(sendTicketsToEmailLoadingSelector);
  const isLaptopOrBigger = useMediaQuery({
    minWidth: breakpoints.laptop,
  });
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <div className="flex w-full gap-2 laptop:flex-row laptop:justify-end">
      <Button
        variant="tertiary"
        type="button"
        onClick={onClose}
        isDisabled={loading}
        data-testid="close-modal-button"
        size={isLaptopOrBigger ? 'regular' : 'large'}
        className="rounded-lg laptop:w-auto"
      >
        <TransText i18nKey="cancel" />
      </Button>
      <Button
        type="submit"
        isDisabled={loading || !!Object.keys(errors).length}
        data-testid="send-emails-button"
        form={formId}
        size={isLaptopOrBigger ? 'regular' : 'large'}
        className="rounded-lg laptop:w-auto"
      >
        <TransText i18nKey="send" />
      </Button>
    </div>
  );
};

export default SendTicketsToEmailFooter;
